import { Dialog, Grid, Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import React, { KeyboardEvent, MouseEvent, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MapLegend } from '../../components/MapLegend'
import { MapSection } from '../../components/MapSection'
import MobileForm from '../../components/MapSection/subComponent/MobileForm'
import { UtilitiesMetrics2 } from '../../components/UtilitiesMetrics'
import { UtilitySlideout } from '../../components/UtilitySlideout'
import { UtilityDetail } from '../../components/UtilitySlideout/subComponents'
import { AppDispatch } from '../../store'
import { AppActions, AppSelector } from '../../store/app'
import { MapRefProps } from './Main'

const SlideUp = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<unknown> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} easing="ease-in-out" timeout={1000} {...props} />
})

export const MainMobile = () => {
  const dispatch = useDispatch<AppDispatch>()
  const mapRef = useRef<MapRefProps | null>(null)
  const mapContainerRef = useRef<HTMLDivElement | null>(null)
  const utilityOpen = useSelector(AppSelector.getMapDataDrawerState)
  const onCloseUtilityDetail = (e: MouseEvent | KeyboardEvent) => {
    dispatch(AppActions.setMapDataDrawerOpen(false))
  }
  return (
    <Grid
      container
      flexDirection="row"
      ref={mapContainerRef}
      sx={{ flexGrow: 1, position: 'relative' }}
    >

      <Dialog
        open={utilityOpen}
        fullScreen
              slots={{
                transition: SlideUp
              }}
        transitionDuration={{enter:500, exit: 1000}}
        sx={{ zIndex: 4000, width: '100%' }}>
        <UtilityDetail onClose={onCloseUtilityDetail} mapRef={mapRef} />
      </Dialog>

      <UtilitiesMetrics2
        CardProps={{
          sx: { position: 'absolute', bottom: '20px', right: '20px', zIndex: 3 },
        }}
      />
      <MapLegend
        CardProps={{
          sx: { position: 'absolute', bottom: '20px', left: '20px', zIndex: 3 },
        }}
      />
      <MapSection ref={mapRef} />
      <MobileForm />
      <UtilitySlideout mapRef={mapRef} />
    </Grid>
  )
}
